import React from 'react'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import ContainerToDownload from '../containers/PDF/ToDownload.container'

/**
 * The Download PDF card page.
 */
const DownloadPage = () => {
  return (
    <AuthorizationProviderContainer>
      <ContainerToDownload />
    </AuthorizationProviderContainer>
  )
}
export default DownloadPage
